"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.23.0
 */
'use client';

import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { EditorTagBadge, EditorTagBadgeIcon } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import '../../../styled-system/css/css.mjs';
import '../../../styled-system/helpers.mjs';
import '../../../styled-system/jsx/is-valid-prop.mjs';
import { Flex } from '../../../styled-system/jsx/flex.mjs';
import '../../../styled-system/patterns/visually-hidden.mjs';

const DeprecatedFormula = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsxs(EditorTagBadge, { variant: "static-value", ref, onClick: props.onClick, onDelete: props.onDelete, children: [
    /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.Function }),
    " Deprecated formula"
  ] });
});
function DeprecatedFormulaDropdown(_) {
  return /* @__PURE__ */ jsx(Flex, { flexDirection: "column", justifyContent: "center", fontWeight: "medium", color: "slate.12", py: "4", children: "This formula is deprecated and cannot be edited." });
}

export { DeprecatedFormula, DeprecatedFormulaDropdown };
